import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateSelectionPipeline, type UpdateSelectionPipelineRequest } from "@/api/selection-api";

import { SELECTION_PIPELINES_QUERY_KEY } from "./use-selection-pipelines";

export const useUpdateSelectionPipeline = () => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (data: UpdateSelectionPipelineRequest) => updateSelectionPipeline(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: SELECTION_PIPELINES_QUERY_KEY });
		},
	});

	return {
		mutate: mutation.mutateAsync,
		isPending: mutation.isPending,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
		error: mutation.error,
	};
};
